import { JsonLd } from 'react-schemaorg';
import { Organization, SearchAction, WebSite } from 'schema-dts';

/**
 * To make typescript pass used this workaround
 * https://github.com/google/schema-dts/issues/33#issuecomment-706680584
 */
type SearchActionWithQueryInput = SearchAction & {
  'query-input': string;
};

const searchAction: SearchActionWithQueryInput = {
  '@type': 'SearchAction',
  target: 'https://www.exploretock.com/search?q={searchbox_target}&referrer=sitelinks_searchbox',
  'query-input': 'required name=searchbox_target',
};

export function HomepageJsonLd() {
  return (
    <>
      <JsonLd<Organization>
        item={{
          '@context': 'https://schema.org',
          '@type': 'Organization',
          name: 'Tock',
          url: 'http://www.exploretock.com',
          sameAs: [
            'http://www.facebook.com/tockhq',
            'http://instagram.com/exploretock',
            'https://www.linkedin.com/company/9204176',
            'http://www.twitter.com/tock',
          ],
        }}
      />
      <JsonLd<WebSite>
        item={{
          '@context': 'https://schema.org',
          '@type': 'WebSite',
          url: 'https://www.exploretock.com/',
          potentialAction: searchAction,
        }}
      />
    </>
  );
}
